import '../WhatsNewModal.scss';

import { Modal } from '@trackman/web-shared-components';
import { Badge } from 'components/Badge/Badge';
import Paragraph from 'components/TextComps/Paragraph';
import SectionTitle from 'components/TextComps/SectionTitle';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { getCurrentNewFeatureContent } from './whatsNewStepperModalConfig';
import { DefaultRoutes } from 'Routes';

export const WhatsNewStepperModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [step, setStep] = useState(1);
  const location = useLocation();
  const { t } = useTranslation();
  const currentNewFeatureContent = getCurrentNewFeatureContent('learningHub');

  useEffect(() => {
    if (!localStorage.isWhatsNewModalDisplayed && location.pathname !== DefaultRoutes.LandingPage) {
      setIsOpen(true);
      localStorage.isWhatsNewModalDisplayed = 'true';
    }
  }, [location.pathname]);

  return (
    <Modal
      cancelBtn={{
        label: t('Skip', { ns: 'whatsNewModal' }),
        onClick: () => setIsOpen(false),
      }}
      confirmBtn={{
        label: step < currentNewFeatureContent.length ? t('Next', { ns: 'whatsNewModal' }) : t('Finish', { ns: 'whatsNewModal' }),
        onClick: () => (step === currentNewFeatureContent.length ? setIsOpen(false) : setStep(step + 1)),
      }}
      onClose={() => setIsOpen(false)}
      title={t('StepCount', { step: step, totalSteps: currentNewFeatureContent.length, ns: 'whatsNewModal' })}
      titleIcon={null}
      open={isOpen}
      className='whats-new-modal'
    >
      <div className='modal-body'>
        <Badge badgeText={t('New', { ns: 'whatsNewModal' })} />
        {currentNewFeatureContent &&
          currentNewFeatureContent?.map((stepContent, index) => (
            <div key={index} className={`step-content ${step === index + 1 ? 'active' : ''}`}>
              <div className='image-wrapper'>
                <img src={stepContent.stepImage} alt={stepContent.stepTitle} />
              </div>
              <SectionTitle>
                <>{stepContent.stepTitle}</>
              </SectionTitle>
              <Paragraph>
                <>{stepContent.stepDescription}</>
              </Paragraph>
            </div>
          ))}
      </div>
    </Modal>
  );
};
